import { BusinessGoalDataResultsApi } from "~/api/BusinessGoalDataResults";

export function useBusinessGoalDataResultsApi(): BusinessGoalDataResultsApi {
  const businessGoalDataApi = new BusinessGoalDataResultsApi(useHttpClient());
    
  return businessGoalDataApi;
}